const intToChar = (int) => {
  const code = 'A'.charCodeAt(0);
  return String.fromCharCode(code + int);
};

export default intToChar;
